import { Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';

import { ModalConfirm } from '@shared/modal/modal.actions';

@Component({
  selector: 'mojo-note-declined-modal',
  templateUrl: './modal-note-declined.component.html',
  styleUrls: ['./modal-note-declined.component.scss'],
})
export class ModalNoteDeclinedComponent {
  comments: UntypedFormControl = new UntypedFormControl();

  @Output()
  reasonsChange = new EventEmitter<string[]>();

  reasons = [
    {
      name: 'Salary not acceptable',
      value: 'SalaryNotAcceptable',
      selected: false,
    },
    {
      name: 'Benefits not acceptable',
      value: 'BenefitsNotAcceptable',
      selected: false,
    },
    {
      name: 'Better offer from other company',
      value: 'BetterOfferFromOtherCompany',
      selected: false,
    },
    {
      name: 'Better offer from existing company',
      value: 'BetterOfferFromExistingCompany',
      selected: false,
    },
    {
      name: 'Other',
      value: 'Other',
      selected: false,
    },
  ];

  form: UntypedFormGroup = new UntypedFormGroup({
    comments: this.comments,
  });

  getConfirmAction() {
    return [new ModalConfirm({ content: this.getComments() })];
  }

  isDisableSave() {
    return this.isAnyReasonSelected() || (this.isSelected('Other') && !this.comments.value);
  }

  isAnyReasonSelected() {
    return this.reasons.filter((reason) => reason.selected === true).length === 0;
  }

  isSelected(value: string) {
    return !!this.reasons.find((reason) => reason.value === value && reason.selected === true);
  }

  getComments() {
    const selectedReasons = this.reasons
      .filter((reason) => reason.selected === true)
      .map((reason) => reason.name);
    return `${selectedReasons.join('. ')}${
      !!this.comments.value ? ': ' + this.comments.value : ''
    }.`;
  }
}
